import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["originalReport", "report"];
import CustomWidgetProps from 'reporting-ui-components/lib/CustomWidgetProps';
import ErrorBoundaryDecorator from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import styled from 'styled-components';
import { getEditLink, getSandboxLink
// @ts-expect-error Untyped dependency
} from '../../../lib/getEditLink';
import { getReportJson } from '../../../lib/getReportJson';
import PropTypes from 'prop-types';
import { UnifiedReportResolver } from './UnifiedReportResolver';
import { useEffect } from 'react';
import { Metrics } from '../../../monitoring/Metrics';
import { REPORT_CONTENT_RESOLVE_TYPE, REPORT_CONTENT_RESOLVE_TYPES } from '../../../constants/trackingMetrics';
import { getValidatedReportTrackingInfo } from './unifiedVizValidationTrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const SeleniumWrapper = styled.div.withConfig({
  displayName: "ReportContent__SeleniumWrapper",
  componentId: "r8qmve-0"
})(["display:contents;overflow:auto;max-height:100%;"]);
function ReportContent(_ref) {
  let {
      originalReport,
      report
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const sandboxReport = originalReport || report;
  const validatedReportTrackingInfo = getValidatedReportTrackingInfo(report);
  useEffect(() => {
    Metrics.counter(REPORT_CONTENT_RESOLVE_TYPE, {
      report_resolve_type: REPORT_CONTENT_RESOLVE_TYPES.UNIFIED_RESOLVE,
      reportType: validatedReportTrackingInfo.reportType,
      chartType: validatedReportTrackingInfo.chartType
    }).increment();
  }, [validatedReportTrackingInfo.reportType, validatedReportTrackingInfo.chartType]);
  return /*#__PURE__*/_jsx(SeleniumWrapper, {
    "data-test-id": "report-loaded",
    className: "@@REPORTING__ENCODED_REPORT",
    "data-encoded-v2": getEditLink(sandboxReport),
    "data-sandbox-link-v2": getSandboxLink(),
    "data-report-json-v2": getReportJson(sandboxReport),
    children: /*#__PURE__*/_jsx(UnifiedReportResolver, Object.assign({
      report: report
    }, rest))
  });
}
ReportContent.propTypes = Object.assign({}, CustomWidgetProps, {
  appUsageTracker: PropTypes.object
});
const WrappedReportContent = ErrorBoundaryDecorator(ReportContent);
export default WrappedReportContent;